export default __webpack_public_path__ + "static/media/21.f2680740.png";